export default __webpack_public_path__ + "static/media/coding.05b5bac5.jpg";